export const EVENT_LEVEL_ATTRIBUTES_TABLE_NAME_TEXT = {
    id: 'oe.eventLevelAttributes.name',
    defaultMessage: 'Name',
    description: 'Label text'
};

export const EVENT_LEVEL_ATTRIBUTES_TABLE_DESCRIPTION_TEXT = {
    id: 'oe.eventLevelAttributes.description',
    defaultMessage: 'Description',
    description: 'Label text'
};

export const EVENT_LEVEL_ATTRIBUTES_TABLE_FIELD_TYPE_TEXT = {
    id: 'oe.eventLevelAttributes.fieldType',
    defaultMessage: 'Field Type',
    description: 'Label text'
};


export const EVENT_LEVEL_ATTRIBUTES_TABLE_DATE_CREATED_TEXT = {
    id: 'oe.eventLevelAttributes.dateCreated',
    defaultMessage: 'Date Created',
    description: 'Label text'
};

export const EVENT_LEVEL_ATTRIBUTES_TABLE_STATUS_TEXT = {
    id: 'oe.eventLevelAttributes.status',
    defaultMessage: 'Status',
    description: 'Label text'
};

export const NO_EVENT_LEVEL_ATTRIBUTES_TEXT = {
    defaultMessage: 'No Event Level Attributes have been created in this account.',
    id: 'oe.eventLevelAttributes.noEventLevelAttributes',
    description: 'Placeholder text',
};
